const COACH_COMPETITIONS_TAB_ID = "CoachCompetitions";

export const shouldShowCompetitionsFromSidebarConfig = (sidebarConfig) => {
  if (!Array.isArray(sidebarConfig) || sidebarConfig.length === 0) {
    return true;
  }

  return !sidebarConfig.some(
    (item) =>
      item?.id === COACH_COMPETITIONS_TAB_ID && item?.visible === false
  );
};

